import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import ImageComponent from "../ImageComponent";
const useStyles = makeStyles((theme) => ({
  root: {
    height: "auto",
    margin:'16px'
  },
  media: {
    width: "100%",
    padding: "20%",
  },
 
}));

export default function ProductCard({
  cardContentTitle,
  cardItemDes,
  cardMediaImage,
  cardContent,
  cardMediaTitle,
  relativeImage,
  buttonText,
  elevation,
  imageStyle
}) {
 
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card variant="elevation" elevation={elevation || 0} className={classes.root} >
      {cardMediaImage && (
        <CardMedia
          component="img"
          className={classes.media}
          image={cardMediaImage}
          title={cardMediaTitle && cardMediaTitle}
        />
      )}
      {relativeImage && (
      <div style={imageStyle}>
          <ImageComponent
            fileName={relativeImage}
            alt={cardContentTitle}
            style={{width:'100%'}}
          />
        </div>
      )}

      {(cardContent || cardContentTitle || cardItemDes) && (
        <CardContent style={{ textAlign: "left" }}>
          {cardContentTitle && (
            <Typography variant="h5" color="textPrimary" component="h4">
              <strong>{cardContentTitle}</strong>
            </Typography>
          )}
          {
            cardContent && 
            <Typography variant="subtitle2" color="textSecondary">
              {cardContent}
            </Typography>
          }
          {cardItemDes && <Typography> {cardItemDes}</Typography>}
        </CardContent>
      )}

      
        <CardActions  >
          
            <Button
              onClick={handleExpandClick}
              aria-label="Learn more"
              color="primary"
              style={{
                textTransform:'initial',
                textAlign:'left',
                justifySelf:'flex-end'
              }}
              
            >
              {buttonText || "Learn more"  }
            </Button>
          
        </CardActions>
      

    </Card>
  );
}
